import { newE2EPage } from "@stencil/core/testing";

describe("popover", () => {
    it("should render a component and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-popover placement="bottom">
                <div>content</div>
                <button type="button" slot="trigger">trigger</button>
            </ux-popover>`
        );
        const el = await page.find("ux-popover");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
    });

    it("should open when trigger element is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-popover placement="bottom">
                <div>content</div>
                <button type="button" slot="trigger">trigger</button>
            </ux-popover>`
        );
        const el = await page.find("ux-popover.hydrated");
        await page.waitForChanges();
        const trigger = await page.find("button[slot=trigger]");
        await trigger.click();
        await page.waitForChanges();
        await page.find(".ux-popover__overlay--opened");
        expect(el.getProperty("opened")).toBeTruthy();
        /** TODO: find a solution for inline styling of the popover causing the
         * snapshot test to be very unreliable
         * expect(el).toMatchSnapshot();
         */
    });

    it("should open and close correctly in controlled mode", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-popover controlled placement="bottom">
                <div>content</div>
                <button type="button" slot="trigger">trigger</button>
            </ux-popover>`
        );
        const el = await page.find("ux-popover.hydrated");
        await page.waitForChanges();
        const overlay = await page.find(".ux-popover__overlay");

        await el.setProperty("opened", true);
        await page.waitForChanges();
        expect(el.getProperty("opened")).toBeTruthy();
        expect(overlay).toHaveClass("ux-popover__overlay--opened");

        await el.setProperty("opened", false);
        await page.waitForChanges();
        expect(overlay).not.toHaveClass("ux-popover__overlay--opened");
        await el.setProperty("opened", true);
    });
});
